import { IconDashboardMeter, IconBarChart, IconConversation, IconHistory, IconBot, IconGroup, IconSetting, IconBotUser, IconConsole, IconEmail } from '../assets/icons';

/* --------------------------LAYOUT SPECIFIC--------------------------- */

export const APP_LAYOUT = {
  //in px
  APP_HEADER_HEIGHT: 60,
  APP_SIDER_COLLAPSE_WIDTH: 60,
  PAGE_NAVBAR_HEIGHT: 50,
  CHAT_LIST_HEADER_HEIGHT: 60
};

export const MODULE_DATA = {
  HISTORY: {
    LOAD_MORE_HISTORY_COUNT: 20
  },
  API_LOGS: {
    LOAD_MORE_API_LOGS_COUNT: 20
  }
};

export const COLORS = {
  primary: '#5a51de', //default
  primary_bg: '#5361d7c4',
  danger: '#ff6d4a',
  aquamarine: '#29bb9c',
  green: '#4CB25C',
  default: '#eff0f4',
  fontcolor: '#d9d9d9',
  fontcolor_light: '#b3b3b3',
};

export const TYPES = {
  EMPTY: 'empty',
  ERROR: 'error'
};

export const APP_SIDER_MENU_TYPE = {
  MENU_ITEM: "menu_item",
  SUB_MENU: "sub_menu",
  PAGE_TAB: "page_tab"
};

export const TEXT_TYPE = {
  USER_TYPED: "userTyped",
  CANNED_RESPONSE: "cannedResponse"
};

/* ----------------------------------------------------------------------- */

export const NLP_SERVICE_NAME = {
  LUIS: "luis",
  RASA: "rasa"
};

export const METHOD_TYPES = {
  GET: "GET",
  POST: "POST",
  DELETE: "DELETE",
  PUT: "PUT",
  PATCH: "PATCH"
};

export const ENTITY_TYPES = {
  SIMPLE: "simple",
  HIERARCHICAL: "hierarchical",
  LIST: "list"
};

export const ROUTE_PATH = {
  AUTH: '/auth',
  LOGIN: '/auth/login',
  FORGOT_PASSWORD: '/auth/forgotpassword',
  RESET_PASSWORD: '/auth/resetpassword',
  ACTIVATE_USER: '/auth/activate',
  DASHBOARD: '/',
  CHATS: '/chats',
  CHAT_HISTORY: '/history',
  ANALYTICS: '/analytics',
  CHATLOG_ANALYTICS: '/analytics/chatlog',
  USAGE_ANALYTICS: '/analytics/usages',
  EVENT_ANALYTICS: '/analytics/event',
  SESSION_FLOW: '/analytics/sessionflow',
  FEEDBACK: '/analytics/feedback',
  FRACTURE: '/analytics/fracture',
  CONVERSIONS: '/analytics/conversions',
  BOT_BUILDER: '/botbuilder',
  WORKFLOWS: '/botbuilder/workflows',
  WORKFLOW_DIAGRAM: '/botbuilder/workflows/:wid',
  BOT_MESSAGES: '/botbuilder/botmessages',
  BRAND_FUNCTIONS: '/botbuilder/brandfunctions',
  EDIT_BRAND_FUNCTION: '/botbuilder/brandfunctions/:brandFunctionId',
  EVENTS: '/botbuilder/events',
  BOT_PARAMS: '/botbuilder/botparams',
  INTENTS: '/botbuilder/intents',
  EDIT_INTENT: '/botbuilder/intents/:intentId',
  ENTITIES: '/botbuilder/entities',
  EDIT_ENTITY: '/botbuilder/entities/id=:entityId?&type=:entityType',
  SETTINGS: '/settings',
  DOWNTIME: '/settings/downtime',
  PROFILE_SETTING: '/settings/profile',
  TEAM_MEMBER_SETTING: '/settings/teammembers',
  MEMBER_PERMISSIONS: '/settings/teammembers/:memberId',
  USERS: '/users',
  USER_PROFILE: '/users/:userId&type=:userIdType',
  MEMBERS: '/members',
  AGENTS: '/members/agents',
  EDIT_AGENT_PROFILE: '/members/agents/edit',
  GROUPS: '/members/groups',
  ADD_GROUP: '/members/groups/add',
  EDIT_GROUP: '/members/groups/edit',
  CANNED_RESPONSES: '/members/canned_responses',
  TAGS: '/members/tags',
  AGENT_MONITORING: '/analytics/agent_monitoring',
  KPI: '/analytics/kpi',
  QUERY_ANALYTICS: '/analytics/query',
  MODEL_ACCURACY: '/analytics/accuracy',
  CONSOLE: '/console',
  API_LOGS: '/console/apilogs',
  REPORTS: '/console/reports',
  EMAIL_SEND_BOX: '/emailsendbox'
};

export const APP_PAGES = {
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgot password',
  RESET_PASSWORD: 'reset password',
  DASHBOARD: 'dashboard',
  CHATS: 'chats',
  CHAT_HISTORY: 'chat history',
  ANALYTICS: 'analytics',
  CHATLOG_ANALYTICS: 'chatlog analytics',
  USAGE_ANALYTICS: 'usage analytics',
  EVENT_ANALYTICS: 'event analytics',
  FEEDBACK: 'feedback',
  FRACTURE: 'Fracture',
  CONVERSIONS: 'conversions',
  SESSION_FLOW: 'session flow',
  BOT_BUILDER: 'bot builder',
  WORKFLOWS: 'workflows',
  BOT_MESSAGES: 'bot messages',
  BRAND_FUNCTIONS: 'brand functions',
  EDIT_BRAND_FUNCTION: 'edit brand function',
  EVENTS: 'events',
  BOT_PARAMS: 'bot params',
  INTENTS: 'intents',
  EDIT_INTENT: 'edit intent',
  ENTITIES: 'entities',
  EDIT_ENTITY: 'edit entity',
  EDIT_SIMPLE_ENTITY: 'edit simple entity',
  SETTINGS: 'settings',
  PROFILE_SETTING: 'Profile/Agent',
  TEAM_MEMBER_SETTING: 'team member',
  MEMBER_PERMISSIONS: 'user permission',
  DOWNTIME: 'downtime',
  USERS: 'users',
  USER_PROFILE: 'user profile',
  MEMBERS: 'members',
  AGENTS: 'agents',
  EDIT_AGENT_PROFILE: 'edit agent profile',
  GROUPS: 'groups',
  ADD_GROUP: 'add group',
  EDIT_GROUP: 'edit group',
  CANNED_RESPONSES: 'canned responses',
  TAGS: 'tags',
  AGENT_MONITORING: 'agent monitoring',
  KPI: 'KPIs',
  QUERY_ANALYTICS: 'query analytics',
  MODEL_ACCURACY: 'model accuracy',
  CONSOLE: 'console',
  API_LOGS: 'API Logs',
  REPORTS: 'reports',
  EMAIL_SEND_BOX: 'email send box'
};

export const APP_SIDER_MENU = [
  {
    type: APP_SIDER_MENU_TYPE.MENU_ITEM,
    Icon: IconDashboardMeter,
    app_page: APP_PAGES.DASHBOARD,
    route_path: ROUTE_PATH.DASHBOARD
  },
  {
    type: APP_SIDER_MENU_TYPE.SUB_MENU,
    Icon: IconBarChart,
    app_page: APP_PAGES.ANALYTICS,
    route_path: ROUTE_PATH.ANALYTICS,
    children: [
      {
        app_page: APP_PAGES.USAGE_ANALYTICS,
        route_path: ROUTE_PATH.USAGE_ANALYTICS
      },
      {
        app_page: APP_PAGES.CHATLOG_ANALYTICS,
        route_path: ROUTE_PATH.CHATLOG_ANALYTICS
      },
      {
        app_page: APP_PAGES.EVENT_ANALYTICS,
        route_path: ROUTE_PATH.EVENT_ANALYTICS
      },
      {
        app_page: APP_PAGES.AGENT_MONITORING,
        route_path: ROUTE_PATH.AGENT_MONITORING
      },
      {
        app_page: APP_PAGES.CONVERSIONS,
        route_path: ROUTE_PATH.CONVERSIONS
      },
      {
        app_page: APP_PAGES.FRACTURE,
        route_path: ROUTE_PATH.FRACTURE
      },
      {
        app_page: APP_PAGES.SESSION_FLOW,
        route_path: ROUTE_PATH.SESSION_FLOW
      },
      {
        app_page: APP_PAGES.FEEDBACK,
        route_path: ROUTE_PATH.FEEDBACK
      },
      {
        app_page: APP_PAGES.KPI,
        route_path: ROUTE_PATH.KPI
      },
      {
        app_page: APP_PAGES.QUERY_ANALYTICS,
        route_path: ROUTE_PATH.QUERY_ANALYTICS
      },
      {
        app_page: APP_PAGES.MODEL_ACCURACY,
        route_path: ROUTE_PATH.MODEL_ACCURACY
      }
    ]
  },
  {
    type: APP_SIDER_MENU_TYPE.MENU_ITEM,
    Icon: IconConversation,
    app_page: APP_PAGES.CHATS,
    route_path: ROUTE_PATH.CHATS
  },
  {
    type: APP_SIDER_MENU_TYPE.MENU_ITEM,
    Icon: IconHistory,
    app_page: APP_PAGES.CHAT_HISTORY,
    route_path: ROUTE_PATH.CHAT_HISTORY
  },
  {
    type: APP_SIDER_MENU_TYPE.MENU_ITEM,
    Icon: IconBotUser,
    app_page: APP_PAGES.USERS,
    route_path: ROUTE_PATH.USERS
  },
  {
    type: APP_SIDER_MENU_TYPE.SUB_MENU,
    Icon: IconConsole,
    app_page: APP_PAGES.CONSOLE,
    route_path: ROUTE_PATH.CONSOLE,
    children: [
      {
        app_page: APP_PAGES.API_LOGS,
        route_path: ROUTE_PATH.API_LOGS
      },
      {
        app_page: APP_PAGES.REPORTS,
        route_path: ROUTE_PATH.REPORTS
      },
    ],
  },
  {
    type: APP_SIDER_MENU_TYPE.PAGE_TAB,
    Icon: IconBot,
    app_page: APP_PAGES.BOT_BUILDER,
    route_path: ROUTE_PATH.BOT_BUILDER,
    children: [
      {
        app_page: APP_PAGES.WORKFLOWS,
        route_path: ROUTE_PATH.WORKFLOWS
      },
      {
        app_page: APP_PAGES.INTENTS,
        route_path: ROUTE_PATH.INTENTS
      },
      {
        app_page: APP_PAGES.ENTITIES,
        route_path: ROUTE_PATH.ENTITIES
      },
      {
        app_page: APP_PAGES.BOT_MESSAGES,
        route_path: ROUTE_PATH.BOT_MESSAGES
      },
      {
        app_page: APP_PAGES.EVENTS,
        route_path: ROUTE_PATH.EVENTS
      },
      {
        app_page: APP_PAGES.BOT_PARAMS,
        route_path: ROUTE_PATH.BOT_PARAMS
      },
      {
        app_page: APP_PAGES.BRAND_FUNCTIONS,
        route_path: ROUTE_PATH.BRAND_FUNCTIONS
      }
    ]
  },
  {
    type: APP_SIDER_MENU_TYPE.PAGE_TAB,
    Icon: IconGroup,
    app_page: APP_PAGES.MEMBERS,
    route_path: ROUTE_PATH.MEMBERS,
    children: [
      {
        app_page: APP_PAGES.AGENTS,
        route_path: ROUTE_PATH.AGENTS
      },
      {
        app_page: APP_PAGES.GROUPS,
        route_path: ROUTE_PATH.GROUPS
      },
      {
        app_page: APP_PAGES.CANNED_RESPONSES,
        route_path: ROUTE_PATH.CANNED_RESPONSES
      },
      {
        app_page: APP_PAGES.TAGS,
        route_path: ROUTE_PATH.TAGS
      }
    ]
  },
  {
    type: APP_SIDER_MENU_TYPE.PAGE_TAB,
    Icon: IconSetting,
    app_page: APP_PAGES.SETTINGS,
    route_path: ROUTE_PATH.SETTINGS,
    children: [
      {
        app_page: APP_PAGES.DOWNTIME,
        route_path: ROUTE_PATH.DOWNTIME
      },
      {
        app_page: APP_PAGES.PROFILE_SETTING,
        route_path: ROUTE_PATH.PROFILE_SETTING
      },
      {
        app_page: APP_PAGES.TEAM_MEMBER_SETTING,
        route_path: ROUTE_PATH.TEAM_MEMBER_SETTING
      },
    ],
  },
  {
    type: APP_SIDER_MENU_TYPE.MENU_ITEM,
    Icon: IconEmail,
    app_page: APP_PAGES.EMAIL_SEND_BOX,
    route_path: ROUTE_PATH.EMAIL_SEND_BOX
  }
];

export const LOCAL_STORAGE = {
  ORI_ADMIN: "dashboardUser",
  VERSION: 'dashboardVersion',
  LIVE_CHATS_UNREAD_MESSAGE_COUNT: 'liveChatsUnreadMessageCount',
  UNSEEN_LIVE_CHATS_STALL_COUNT: 'unseenLiveChatStallCount',
  BIFURCATION_DATA: "bifurcationData",
};

export const PLATFORM = {
  WEBSITE: "website",
  FACEBOOK: "facebook",
  ANDROID: "android",
  IOS: "ios",
  WHATSAPP: "whatsapp",
  GOOGLE_ANALYTICS: "ga"
};

export const SOCKET_EVENTS = {
  //-------------------- common events --------------------

  CONNECT: "connect",
  CONNECT_ERROR: "connect_error",
  CONNECT_TIMEOUT: "connect_timeout",
  ERROR: "error",
  RECONNECT: 'reconnect',
  RECONNECT_ERROR: 'reconnect_error',
  RECONNECTING: 'reconnecting',
  DISCONNECT: 'disconnect',
  DIAGNOSE: 'diagnose',

  //-------------------- chats events --------------------

  ADDITION: "addition",
  DELETION: "deletion",
  UPDATION: "updation",
  JOIN: "join",
  LEAVE: "leave",
  TAG_ADDITION: "tagAddition",
  JOIN_UNTAGGED_CHATS: "joinUntaggedChats",
  CHAT_ACCEPTED: "chat_accepted",
  CHAT_REJECTED: "chat_rejected",
  JOIN_ROOM: "joinRoom",
  SUPERVISE: "supervise",
  STOP_SUPERVISING: "stopSupervising",
  RESOLVE_CHAT: "resolve_chat",
  ADMIN_TO_USER_MSG: "adminToUserMsg",
  WHISPER: "whisper",
  RESPONSE: "response",
  USER_MESSAGE: "userMessage",
  JOIN_AGENT_TRANSFER: "joinAgentTransfer",
  TRANSFER_AVAILABILITY_LIST: "transferAvailabilityList",
  LEAVE_AGENT_TRANSFER: "leaveAgentTransfer",
  TRANSFER_CHAT: "transfer_chat",
  AVAILABILITY_UPDATE: "availabilityUpdate",
  GET_AGENT_STATE: "getAgentStates",
  CHANGE_AGENT_STATE: "changeAgentState",
  TYPING_STATUS: "typingStatus",
  UPDATE_CUSTOMER_MESSAGE: "updateCustomerMessage",
  UPDATE_MESSAGE: "updateMessage",
  MESSAGE_SEEN: "messageSeen",
  FORCE_TAKEOVER: "forceTakeOver",
  ADD_TAG_TO_CHAT: "addTagToChat",
  REMOVE_TAG_FROM_CHAT: "removeTagFromChat",
  ESCALATE: "escalate",
  BLANK: "blank",
  DOWNTIME: "downTime",
  FORCE_LOGOUT: "forceLogout",
  PENDING_CHAT_TIMEOUT: "pendingChatTimeout",

  TAKEOVER: "takeover",
  RELINQUISH: "relinquish",

  //-------------------- agent monitoring events --------------------

  JOIN_GROUP_LIVE_STATS: "joinGroupLiveStats",
  LEAVE_GROUP_LIVE_STATS: "leaveGroupLiveStats",
  GROUP_LIVE_STATS: "groupLiveStats",

  JOIN_AGENT_LIVE_STATS: "joinAgentLiveStats",
  LEAVE_AGENT_LIVE_STATS: "leaveAgentLiveStats",
  AGENT_LIVE_STATS: "agentLiveStats",

  GET_AGENT_CHATS: "getAgentChats",

  //-------------------- dashboard events --------------------

  JOIN_LIVE_STATS: "joinLiveStats",
  LEAVE_LIVE_STATS: "leaveLiveStats",
  PER_SECOND_STATS: "perSecondStats",
  PER_MINUTE_STATS: "perMinuteStats",
  LAST_N_HOURS_TIME_SERIES: "lastNHoursTimeSeries",

  //--------------------- usages events ----------------------

  DETAILED_CHAT_STATS: "detailedChatStats"
};

export const HANDLING_ALERT = {
  LONG: "long",
  CRITICAL: "critical"
}

export const CHAT_STATE = {
  PENDING: "Pending",
  AGENT_HANDLING: "AgentHandling",
  BOT_HANDLING: "BotHandling",
  IN_QUEUE: "Inqueue"
};

export const CHAT_LIST_TYPE = {
  PENDING: "pending",
  IN_QUEUE: "in queue",
  MY_CHAT: "my chats",
  AGENT_CHATS: "agent chats",
  SUPERVISED: "supervised",
  BOT_HANDLING: "bot handling",
  UNTAGGED_CHATS: "untagged chats"
};

export const REVIEW_STATUS = {
  PENDING: "pending",
  COMPLETE: "complete"
};

export const INPUT_COMPOSER_TYPE = {
  BARGE: "barge",
  WHISPER: "whisper"
};

export const CHAT_TRANSFER_TO = {
  AGENT: "agent",
  GROUP: "group"
};

export const AGENT_INVITATION_WITH = {
  EMAIL: "email",
  USER_NAME: "userName"
};

export const AGENT_STATUS = {
  ACCEPTING: "accept chats",
  NOT_ACCEPTING: "don't accept chats"
};

export const MESSAGE_TYPES = {
  TEXT: "text",
  SYSTEM_TEXT: "systemText",
  TEXT_WITH_BUTTONS: "text_with_buttons",
  IMAGE_WITH_BUTTONS: "image_with_buttons",
  VIDEO: "video",
  TIMER: "timer",
  CAROUSEL: "carousel",
  CUSTOM_MSG: "customMsg",
  LINK: "link",
  QUICK_RESPONSE: "quick_response",
  WHISPER: "whisper",
  CHECKBOX_WITH_MEDIA: "checkbox_with_media",
};

export const MESSAGE_SUBTYPES = {
  DISH_RECHARGE: "dishRecharge",
  DISH_RECHARGE_DETAILS: "dishRechargeDetails",
  DISH_OFFERS: "dishOffers",
  DISH_RECHARGE_HISTORY: "dishRechargeHistory"
};

export const MESSAGE_SENDER = {
  CUSTOMER: "customer",
  CHATBOT: "chatbot",
  ADMIN: "admin",
  SYSTEM: "system"
};

export const MESSAGE_READ_STATUS = {
  SENT: "sent",
  DELIVERED: "delivered",
  SEEN: "seen",
  FAILED: "failed"
};

export const NODE_TYPE = {
  WORKFLOW: "Workflow",
  NODE: "Node"
};

export const GRAPH_TYPE = {
  LINE: "line",
  AREA: "area",
  INTERVAL: "interval",
  INTERVAL_STACK: "intervalStack"
};

export const ORIENTATION = {
  LANDSCAPE: "landscape",
  PORTRAIT: "portrait"
};

export const CHATBOT_CONTROL = {
  TAKEOVER: "takeover",
  RELINQUISH: "relinquish"
};

export const CURRENCY = {
  RUPEES: "rupees",
  DOLLAR: "dollar"
};

export const BOT_EVENT_SOURCE = {
  CALL: "call",
  CHAT: "chat",
  EMAIL: "email"
};

export const PANEL_KEY = {
  LIVE_CHAT: "live",
  TAKE_OVER: "takeover",
  NEED_ATTENTION: "need attention"
};

/* value should be same as backend type** ie value in lowercase; */

export const PROFILE_ITEM_TYPE = {
  DATE: "date",
  CURRENCY: "currency",
  DATE_TIME: "datetime",
  URL: "url"
};

export const FILTER_TYPE = {
  CHECKBOX: "checkbox",
  INPUT_NUMBER: "inputNumber",
  INPUT_STRING: "inputString",
  INPUT: "input",
  RADIO: "radio",
  RADIO_GROUP_WITH_MULTI_OPTIONS: "radioGroupWithMultiOptions"
};

export const LIVE_CARD_TYPE = {
  TOTAL: "total",
  WEBSITE: "website",
  ANDROID: "android",
  FACEBOOK: "facebook",
  AVG_FEEDBACK: "averageFeedback",
  SESSIONS: "sessions",
  SESSIONS_PER_USER: "sessionsPerUser",
  SESSION_TIME_PER_USER: "sessionTimePerUser",
  MESSAGES_PER_USER: "messagesPerUser",
  DAU: "DAU",
  WAU: "WAU",
  MAU: "MAU"
};

export const PERMISSIONS = {
  ACTION_TYPES: {
    CREATE: "create",
    UPDATE: "update",
    READ: "read",
    DELETE: "delete"
  },
  ACTIONS: {
    INTENT: "intent",
    ENTITY: "entity",
    WORKFLOW: "workflow",
    BOT_MESSAGE: "botMessage",
    EVENT: "event",
    INSIGHT: "insight",
    BOT_DEVELOPMENT: "botDevelopment",
    TRAIN_MESSAGES: "trainMessages",
    TEAM_MANAGEMENT: "teamManagement",
    UTTERANCE: "utterance"
  },
  EVENTS: {
    TAKEOVER: "takeover"
  }
};



// WEBPACK FOOTER //
// ./src/data/config/constants.js